import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { DatePipe } from '@angular/common';
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { CustomerService } from "../services/customer.service";
import { CustomerServiceConstants } from "../../common/constants/customer-service.constants";
import { SearchRequest } from "../interface/search-request";
import { SearchModel } from "../interface/search-model";    //Model to binding elements from UI
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MULTI_SELECT_CONFIG_SearchBy } from '../selectize/selectize.searchBy.config';
import { Constants, SearchResponseType} from '../common/constants';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SearchRequestConstants } from '../common/search-request-constants';
import { SearchCriteria } from "../interface/search-criteria";  // key - vaule pair model - for search request.
import { FBOResponse } from "../interface/fbo-response";    // fbo information model.
import { SearchResponse } from "../interface/search-response";  // main response model.
import { RetailResponse } from "../interface/retail-response";  // retail customer info model.
import { OrderResponse } from "../interface/order-response";    // fbo / retail order response model.
import { AccountModel } from "../models/account-model";    // recent details model
import { RecentDetailsResponse } from "../interface/recent-details-response";   // recent details response model
import { CacheService } from "../../shared/services/cache.service";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { DynamicTabsComponent } from '../components/dynamic-tabs.component';
import { MessageService } from "../../shared/services/message.service";
import { DataShareService } from "../../shared/services/data.service";
import { Permission } from "../../common/enums/permission.enum";
import { CommonService } from "../../shared/services/common.service";
import { CommonMessage } from "../common/common-messages";
import { DeleteModal } from "../models/delete-modal";
import { ISubscription } from "rxjs/Subscription";
import { PaginationInstance } from 'ngx-pagination';
import { DistributorSearchEnums } from "../enums/distributor-search.enum";
import { Utils } from "../../shared/Utils/utils";
import { OrderService } from "../services/order.service";
import { PurchaseFlow, OrderType } from "../common/enumerations";
import { StatusConstants } from "../constants/status.constants";
import { Modal } from "../../../../node_modules/ngx-modal";
import { NgProgress } from "../../../../node_modules/ngx-progressbar";
import * as moment from 'moment';
import { HomeCountryEnums, OperatingCountryEnums } from "../enums/countries.enums";
import { SearchSettingsModal } from "../models/searchSettings-modal";
import { environment } from "../../../environments/environment";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { MemberSearchByFboIdResponse } from "../interface/member-search-by-fboid-response";
import { DistributorInfo } from "../interface/ticketingsystem/distributor-info";
import { ProfileInformation } from "../interface/profile-info";
import { OrderInfoForNavigation } from "../interface/order-info-navigate";
import { TranslateService } from "@ngx-translate/core";
import { DateConstants } from '../constants/date.constants';
import { SourceTypeConstant } from "../constants/source-type.contants";
import { AccountRestrictionStatus } from "../../common/enums/account-restricted.enum";

@Component({
    selector: "customer-search",
    templateUrl: "../templates/template1/views/search.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/search.less","../templates/template1/themes/default/less/print-preview.less"
    ],
    providers: [AuthorizationPipe, CustomerService, DatePipe, DynamicTabsComponent]
    //encapsulation: ViewEncapsulation.None
})

export class SearchComponent implements OnInit {

    statusTypes: any[] = CustomerServiceConstants.STATUSTYPES;

    FBODetailPermissions: any[] = [Permission.FBO_PROFILE_VIEW, Permission.FBO_ORDER_HISTORY_VIEW,
    Permission.FBO_AUTOSHIP_DETAILS_VIEW, Permission.FBO_PAYMENT_METHODS_VIEW,
    Permission.FBO_DOWNLINE_VIEW, Permission.FBO_REPORTS_VIEW, Permission.MANAGE_TICKETS_VIEW];
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    retailPermissions: any[] = [Permission.CUSTOMER_DETAILS_VIEW, Permission.CUSTOMER_ORDER_HISTORY_VIEW];

    deleteModal: DeleteModal;

    fieldTypes: SearchRequestConstants;    // constants for field names - value of search key in request

    searchRequest: SearchRequest;       // API request model
    searchCriteria: any;    // Key & value model
    searchCriteriaList: SearchCriteria[];   //list of search criteria
    customerSearchModel: any;   // contains UI fields

    fboPanel: boolean = true;
    fboOrderPanel: boolean = false;
    retailPanel: boolean = false;
    retailOrderPanel: boolean = false;
    fboProfileInfo: ProfileInformation;
    // variables to view/hide grid details
    fboPanelGrid = true;
    fboOrderPanelGrid = false;
    retailPanelGrid = false;
    retailOrderPanelGrid = false;

    isAdvancedSearch: boolean = true;
    viewRightPanel = false;
    isLoading: boolean = false;
    // config for multi select
    searchBy_config: any = MULTI_SELECT_CONFIG_SearchBy;

    states: any[];
    countries: any[];
    searchByOrderCountries: any[];

    disableState: boolean = false;   // to enable states dropdown

    sortColumn: string = "fboId";
    sort: string = "DESC";

    pageNumber: number = 1;
    pageSize: number = 25;
    pageCount: number = 0;
    ordersPageCount: number = 0;
    isDesc: boolean = false;

    isSearch: boolean = false; // to display validation message

    searchScreenWidth: number;

    //response models
    searchResponse: any;

    //recent search variables
    recentDetailsResponse: any;
    userId: any;
    showMandatoryValidationMessage: boolean;
    showHomeCountryValidationMessage: boolean;
    // persist search data
    recentSearch: SearchModel;
    //key for storing the value in cache service
    recentSearchKey: string = "recentSearch";
    // parameter for back to search
    urlParam: string;

    applyMD4Class = true;
    isOpenTabsExisted = false;

    searchSubscription: ISubscription;
    isSearchCancelled: boolean = false;
    isOrderSearch: boolean;

    viewPermission: boolean;
    orderhistoryPermission: boolean;
    lastDigitModel: any;


    searchForm: FormGroup;
    distributorEnum: any = [DistributorSearchEnums.By_Member, DistributorSearchEnums.By_Name, DistributorSearchEnums.By_OrderId, DistributorSearchEnums.By_CardNumber];
    searchType: string = DistributorSearchEnums.By_Member.toString();
    isSubmitted: boolean = false;
    searchReqValues: any;
    @ViewChild('memberInfoInput') memberInfoInput: ElementRef;
    @ViewChild('byNameInput') byNameInput: ElementRef;
    @ViewChild('byOrderInput') byOrderInput: ElementRef;
    @ViewChild('byLast4Input') byLast4Input: ElementRef;

    @ViewChild('focusMemberName') focusMemberName: ElementRef;
    @ViewChild('cancelOrderModal') cancelOrderModal: Modal;
    @ViewChild('memberRestrictionModal') memberRestrictionModal: Modal;
    @ViewChild('searchButtton') searchButtton: ElementRef;
    memberInfoTabIndex: number = 1;
    byCardTabIndex: number = 1;
    byOrderTabIndex: number = 1;
    byNameTabIndex: number = 1;
    invalidToDate: boolean = false;
    selectedSearchType: any = this.distributorEnum[0];
    sortByColumn: any;
    sortByCreditCard: string = "DESC";
    isFromTitan: boolean;
    searchComponentSettings: SearchSettingsModal;
    FBORegularOrderPermissions: number[] = [
        Permission.REGULAR_ORDER_VIEW,
        Permission.REGULAR_ORDER_MANAGE,
        Permission.REGULAR_ORDER_CANCEL
    ];
    FBOPOSOrderPermissions: number[] = [
        Permission.POS_ORDER_VIEW,
        Permission.POS_ORDER_MANAGE,
        Permission.POS_ORDER_CANCEL
    ]
    hasRegularOrderViewPermission: boolean;
    hasPOSOrderViewPermission: boolean;
    orderGroup = OrderType;
    sources: any;
    type: string;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    memberDetails: any;
    accountRestriction: boolean = false;
    accountStatus: any;
    accountManagePermission: boolean = false;
    accountViewPermission: boolean = false;
    FindAccountUsingAlternativeLanguagePermission:number = Permission.ALTERNATIVE_LANGUAGE_SEARCH_PERMISSION;
    hasAlternativeLanguageSearch:boolean = false;
    ngOnInit(): void {
        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'csp-search';
        }
        this.getSources();
        this.searchComponentSettings = new SearchSettingsModal(9, 0);
        this.createForm(true);
        this.viewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBODetailPermissions[0] + "]"),AccessLevel.Customer_Service);
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
        this.accountManagePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[1] + ']'), AccessLevel.Customer_Service);        
        this.hasRegularOrderViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBORegularOrderPermissions + "]"),AccessLevel.Customer_Service);
        this.hasPOSOrderViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOPOSOrderPermissions + "]"),AccessLevel.Customer_Service);
        this.hasAlternativeLanguageSearch = this._commonService.checkPermissionByAccessLevel(JSON.parse("["+ this.FindAccountUsingAlternativeLanguagePermission +"]"),AccessLevel.Customer_Service);
        // To update the right content width
        this._dataShareService.customerServiceMessage.subscribe(message => {
            if (message && message !== '') {
                var splittedMessage = message.split('-');
                var rightContentWidth = parseInt(splittedMessage[0]);
                this.searchScreenWidth = this.viewRightPanel ? (rightContentWidth - 260) : rightContentWidth;
                this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
            }
        });

        this.orderhistoryPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBODetailPermissions[1] + "]"),AccessLevel.Customer_Service);
        // Event to be executed - After clicking on Remove all tabs. -- That div shouldn't be displayed in UI
        // Once all tabs are removed...
        this.subscribeEventOnCloseAllTabs();

        this.subscribeOpenedTabsInformation();

        this.searchRequest = new SearchRequest();
        this.fieldTypes = new SearchRequestConstants();

        this.getCustomerSearchInstance();
        this.customerSearchModel.searchKey = this.fieldTypes.FBOID;
        this.customerSearchModel.searchKeyInput = "";
        this.searchCriteria = new SearchCriteria();
        this.disableState = true;

        this.getSearchResponseInstance();
        this.loadRecentlyViewedItems();
        this.clearRecentlyViewedDetails();
        this.userId = this._cacheService.get(CacheKey.UserId);
        this.getRecentSearchDetails(this.userId);
        this.route.params.subscribe((params: Params) => {
            this.urlParam = params["id"];
            if (this.urlParam == this.recentSearchKey) {
                let lastData = this._cacheService.get(this.recentSearchKey);
                if (lastData) {
                    this.customerSearchModel.searchBy = lastData.searchBy;
                    this.changeSearchType(this.customerSearchModel.searchBy);
                    this.customerSearchModel.searchKey = lastData.searchKey;
                    this.customerSearchModel.searchKeyInput = lastData.searchKeyInput;
                    if (lastData.isAdvancedSearch) {
                        this.isAdvancedSearch = lastData.isAdvancedSearch;
                        if (lastData.firstName) {
                            this.customerSearchModel.firstName = lastData.firstName;
                        }
                        if (lastData.middleName) {
                            this.customerSearchModel.middleName = lastData.middleName;
                        }
                        if (lastData.lastName) {
                            this.customerSearchModel.lastName = lastData.lastName;
                        }
                        if (lastData.fboId) {
                            this.customerSearchModel.fboId = lastData.fboId;
                        }

                        if (lastData.userName) {
                            this.customerSearchModel.userName = lastData.userName;
                        }
                        if (lastData.fourDigitSSN) {
                            this.customerSearchModel.fourDigitSSN = lastData.fourDigitSSN;
                        }
                        if (lastData.email) {
                            this.customerSearchModel.email = lastData.email;
                        }
                        if (lastData.phoneNumber) {
                            this.customerSearchModel.phoneNumber = lastData.phoneNumber;
                        }
                        if (lastData.city) {
                            this.customerSearchModel.city = lastData.city;
                        }
                        if (lastData.state) {
                            this.customerSearchModel.state = lastData.state;
                        }
                        if (lastData.homeCountry) {
                            this.customerSearchModel.homeCountry = lastData.homeCountry;
                        }
                        if (lastData.sponsor) {
                            this.customerSearchModel.sponsor = lastData.sponsor;
                        }
                        if (lastData.status) {
                            this.customerSearchModel.status = lastData.status;
                        }
                        if (lastData.orderNumber) {
                            this.customerSearchModel.orderNumber = lastData.orderNumber;
                        }
                        if (lastData.orderId) {
                            this.customerSearchModel.orderId = lastData.orderId;
                        }
                        if (lastData.country) {
                            this.customerSearchModel.country = lastData.country;
                        }
                        if (lastData.referringFBOId) {
                            this.customerSearchModel.referringFBOId = lastData.referringFBOId;

                        }
                        if (lastData.lastFourDigitsOfCC) {
                            this.customerSearchModel.lastFourDigitsOfCC = lastData.lastFourDigitsOfCC;

                        }
                        if (lastData.fromDate) {
                            this.customerSearchModel.fromDate = lastData.fromDate;

                        }
                        if (lastData.toDate) {
                            this.customerSearchModel.toDate = lastData.toDate;
                        }
                    }
                    this.onSearch();
                }
            } else {
                this._cacheService.set(this.recentSearchKey, '');
            }
        });
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        if (this._cacheService.getSessionValue(CacheKey.DistributorInfo)) {
            const distributorInfo: DistributorInfo = this._cacheService.getSessionValue(CacheKey.DistributorInfo);
            this.navigateToFBOProfile(distributorInfo.distributorId, distributorInfo.memberType, distributorInfo.name);
        }
        if (this._cacheService.getSessionValue(CacheKey.FboProfileDetail)) {
            const fboProfileDetail: ProfileInformation = this._cacheService.getSessionValue(CacheKey.FboProfileDetail);
            this.navigateToFBOProfile(fboProfileDetail.fboId, fboProfileDetail.memberType, fboProfileDetail.firstName);
        }
        if (this._cacheService.getSessionValue(CacheKey.ORDER_INFO_SESSION_CODE)) {
            const orderInfoForNavigation: OrderInfoForNavigation = this._cacheService.getSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
            this.loadWebOrderDetailPage(orderInfoForNavigation);
        }
    }

  getSources() {
    this._customerService.getSources().subscribe((res) => {
      try {
        if (res) {
          this.sources = res;
          this._cacheService.set('sources', this.sources);
        }
      } catch (error) {
        this.sources = [];
      }
    }, error => {
      this.sources = [];
    });
  }

    /**
     *
     * @param orderInfoForNavigation
     */
    loadWebOrderDetailPage(orderInfoForNavigation: OrderInfoForNavigation) {
        if (orderInfoForNavigation && orderInfoForNavigation.webOrderNumber || orderInfoForNavigation.orderNumber) {
            this.searchType = this.distributorEnum[2];
            this.createForm(true, this.distributorEnum[2]);
            if (!orderInfoForNavigation.webOrderNumber) {
                this.searchForm.controls['orderInfo'].setValue(orderInfoForNavigation.orderNumber);
            } else {
            this.searchForm.controls['orderInfo'].setValue(orderInfoForNavigation.webOrderNumber);
            }
            this.search();
        } 
    }

    // ngAfterContentChecked() {
    //     this.checkValidationForFromDate();
    // }

    constructor(private _customerservice: CustomerService, private _router: Router,
        private _formbuilder: FormBuilder,
        private _cacheService: CacheService, private route: ActivatedRoute
        , private router: Router, private _dynamicTabsComponent: DynamicTabsComponent,
        private messageService: MessageService, private _dataShareService: DataShareService,
        private _commonService: CommonService,
        private _orderservice: OrderService,
        private _customerService: CustomerService,
        private ngProgress: NgProgress,
        private _translatePipe: TranslateService) { }

    /**
        * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
    */
    subscribeOpenedTabsInformation() {
        this.messageService.getOpenTabsInfo().subscribe((data: any) => {
            if (data) {
                this.isOpenTabsExisted = data;
            }
        });
    }

    /**
    * Event to be subscribed once all tabs are removed -- Inorder to not to display 'Remove all tabs' link in UI
    */
    subscribeEventOnCloseAllTabs() {
        this._dataShareService.onCloseAllTabsMessage.subscribe(message => {
            if (message && message !== '') {
                var splittedMessage = message.split('-');
                this.isOpenTabsExisted = (parseInt(splittedMessage[0]) === 1 ? true : false);
            }
        });
    }

    /**
     * @description to load recently viewed items
     * @date 2019-06-26
     * @memberof SearchComponent
     */
    loadRecentlyViewedItems(): void {
        this.messageService.getRecentlyViewedInfo().subscribe((data: boolean) => {
            this.getRecentSearchDetails(this.userId);
        });
    }

    /**
    * on clicking of "No" this method will be called.
    */
    doNotRemoveFormData() {
        //data should not be removed...
    }

    /**
     * gets instance of customer search model
     */
    getCustomerSearchInstance() {
        this.customerSearchModel = new SearchModel();
        this.customerSearchModel.searchBy = Constants.FBO;
        this.customerSearchModel.searchKey = this.fieldTypes.FBOID;
        this.customerSearchModel.status = this.statusTypes[1].value;
    }

    /**
     * get instance of search response
     */
    getSearchResponseInstance() {
        this.searchResponse = new SearchResponse();
        this.searchResponse.fboSearchResultModelList = new Array<FBOResponse>();
        this.searchResponse.customerResultModelList = new Array<RetailResponse>();
        this.searchResponse.orderModelList = new Array<OrderResponse>();
    }

    /**
     * clears list and hides the right panel.
     */
    clearRecentlyViewedDetails() {
        this.viewRightPanel = false;
        this.recentDetailsResponse = new RecentDetailsResponse();
        this.recentDetailsResponse.fboUsers = new Array<AccountModel>();
        this.recentDetailsResponse.retailUsers = new Array<AccountModel>();
        this.recentDetailsResponse.preferredUsers = new Array<AccountModel>();
    }
    public paginationInstance: PaginationInstance = {
        id: 'search-member-pagination',
        itemsPerPage: 10,
        currentPage: 1
    };

    /**
     * updating pagination variables...
     */
    updatePaginationVariables() {
        this.pageNumber = 1;
        this.pageSize = 25;
        this.pageCount = 0;
        this.isDesc = true;
        this.sort = this.isDesc ? "DESC" : "ASC";
        this.ordersPageCount = 0;
    }
    /**
     * on Change of search type to view Advanced fields..
     * @param searchBy
     */
    changeSearchType(searchBy: String) {
        this.getCustomerSearchInstance();
        this.customerSearchModel.searchBy = searchBy;

        this.updatePaginationVariables();
        this.isSearch = false; // to display validation message

        // hiding of grids...
        this.fboPanelGrid = false;
        this.fboOrderPanelGrid = false;

        if (this.customerSearchModel.searchBy === Constants.FBO) {
            this.sortColumn = "fboId";
            this.fboOrderPanel = false;
            this.retailPanel = false;
            this.retailOrderPanel = false;
            this.fboPanel = true;
            this.disableState = true;
            this.customerSearchModel.searchKey = this.fieldTypes.FBOID;
        }
        else if (this.customerSearchModel.searchBy === Constants.Retail) {
            this.sortColumn = "userName";
            this.fboPanel = false;
            this.fboOrderPanel = false;
            this.retailOrderPanel = false;
            this.disableState = false;
            this.retailPanel = true;
            this.getStatesByCountry(0);
            this.customerSearchModel.searchKey = this.fieldTypes.USERNAME;
        }
        else if (this.customerSearchModel.searchBy === Constants.FBO_Orders) {
            this.sortColumn = "fboId";
            this.fboPanel = false;
            this.retailPanel = false;
            this.retailOrderPanel = false;
            this.fboOrderPanel = true;
            this.customerSearchModel.searchKey = this.fieldTypes.FBOID;
        }
        else if (this.customerSearchModel.searchBy === Constants.Retail_Orders) {
            this.sortColumn = "userName";
            this.fboPanel = false;
            this.fboOrderPanel = false;
            this.retailPanel = false;
            this.retailOrderPanel = true;
            this.customerSearchModel.searchKey = this.fieldTypes.USERNAME;
        }
        this.fboPanelGrid = false;
        this.fboOrderPanelGrid = false;
        this.retailPanelGrid = false;
        this.retailOrderPanelGrid = false;
        this.clearRecentlyViewedDetails();
        const adminContent = document.getElementById('admin-content');
        if (adminContent) {
            this.searchScreenWidth = adminContent.offsetWidth;
        }
        this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
    }

    /** * HITS SERVICES   ----- BEGIN ----- ************************* */
    /**
     * Gets all the countries
     */
    getCountries() {
        this._customerservice.getStoreCountries().subscribe(response => {
            if (response) {
                this.countries = response;
                this.searchByOrderCountries = response.slice(0);
                let usaInfo = this.countries.find((country: any) => country.id === HomeCountryEnums.USA);
                let canInfo = this.countries.find((country: any) => country.id === HomeCountryEnums.CAN);
                this.countries.splice(this.countries.indexOf(usaInfo), 1);
                this.countries.splice(this.countries.indexOf(canInfo), 1);
                this.countries.splice(0, 0, canInfo);
                this.countries.splice(0, 0, usaInfo);
                let order_country = {id : 0, name : this.fieldTypes.ALL, value:this.fieldTypes.ALL };
                this.countries.splice(0, 0, order_country);
                this.searchByOrderCountries.splice(0,0,order_country);
                if ((+this.searchType === this.distributorEnum[1]) || (+this.searchType === this.distributorEnum[2])) {
                    this.createForm(true);
                }
            }
        });
    }

    /**
     * Gets states by country Id
     * @param id
     */
    getStatesByCountry(id: Number) {
        this._customerservice.getStatesByCountry(id).subscribe(response => {
            if (response) {
                this.states = response;
            } else {
                this.states = [];
            }
        });
    }

    /**
     * Get recent search details
     * @param userId
     */
    getRecentSearchDetails(userId: number) {
        this._customerservice.getRecentSearchDetails(userId).subscribe(response => {
            if (response) {
                this.recentDetailsResponse = response;
            }
        });
    }

    searchPolling(response: any) {
        if ((response.status === SearchResponseType.IN_PROGRESS) || (response.status === SearchResponseType.QUEUED)) {
            if (this.searchComponentSettings.pollCount < this.searchComponentSettings.maxPollCount) {
                this.searchComponentSettings.pollCount = this.searchComponentSettings.pollCount + 1;
                this.getSearchResults(response.location);
            }
        }
    }


    /**
     * Gets search results
     */
    getSearchResults(url?: string) {
        this.isFromTitan = false;
        this.isLoading = true;
        this.searchRequest.pageNumber = this.pageNumber;
        this.searchRequest.pageSize = this.pageSize;
        this.searchRequest.sort = this.sort;
        this.searchRequest.sortOrder = [];
        this.searchRequest.sortOrder.push(this.sortColumn);
        this.searchRequest.isAdvancedSearch = !this.isAdvancedSearch;
        this.searchRequest.searchAccountUsingAlternativeLanguage = this.searchForm.get('alternativeLanguageSearch').value ;       
        if (this.searchForm.controls['memberGovtInfo'].value) {
            this.searchSubscription = this._customerservice.getSearchResultsByGovtId(this.searchForm.controls['memberGovtInfo'].value).subscribe(response => {
                    this.accountSearchResponse(response, false);
                    this.resetAlternativeLanguageSearchField();
                }, error => {
                    this.searchErrorResponse(error);
                    this.resetAlternativeLanguageSearchField();
                }, () => {
                    this.isLoading = false;
                });
        } else {
            this.type = null;
            if (this.sources && this.sources.length > 0 && +this.searchType === this.distributorEnum[1]) {
                if (this.countries && this.searchForm.controls['country'].value) {
                    const selectedCountry = this.countries.find(country => country.id === this.searchForm.controls['country'].value);
                    this.sources.forEach(source => {
                        if (source.countryCode === selectedCountry.value) {
                            this.type = source.source;
                        }
                    });
                } else if (this.searchForm.controls['country'].value === 0) {
                           this.type = SourceTypeConstant.TITAN_AS400 ;
                }
            }  else if (this.sources && this.sources.length > 0 && +this.searchType === this.distributorEnum[0]) {
                this.sources.forEach(source => {
                    if (source.serachBy = 'MEMBER') {
                        this.type = source.source;
                    }
                });
            }
            else if (this.sources && this.sources.length > 0 && +this.searchType === this.distributorEnum[2]) {
                let searchCriteria:any = this.searchRequest.searchCriteria[0];
                if( !searchCriteria.searchValue.includes("_") && this.searchForm.controls['orderInfo'].valid){
                this.sources.forEach(source => {
                    if (source.serachBy = 'ORDER') {
                        this.type = 'AS400';
                    }
                });
            }else{
                this.isLoading = false;
            }
            }
            
            if (this.type && this.type === SourceTypeConstant.TITAN_AS400) {
                this._commonService.getFBOSearchResults(this.searchRequest).subscribe(
                    (response: MemberSearchByFboIdResponse) => {
                        if (response && response.recordsCount > 0 && response.fboSearchResultModelList) {
                            response.status = SearchResponseType.COMPLETED;
                            this.accountSearchResponse(response, true);
                            this.memberDetails = response;
                            if(response && response.fboSearchResultModelList && response.fboSearchResultModelList.length){
                                const distributorID = response.fboSearchResultModelList[0].fboId;   
                                this.getAccountStatus(distributorID);
                            }
                            this.resetAlternativeLanguageSearchField();
                        } else {
                            this.getAS400Search(url);
                            this.resetAlternativeLanguageSearchField();
                        }
                    }, error => {
                        this.searchErrorResponse(error);
                        this.resetAlternativeLanguageSearchField();
                    }, () => {
                        this.isLoading = false;
                    });

            } else if (this.type && this.type === SourceTypeConstant.AS400) {
                this.getAS400Search(url);
                this.resetAlternativeLanguageSearchField();
            }


        }
    }

    getAS400Search(url?: string):void{
        this.searchSubscription = this._customerservice.getSearchResults(this.searchRequest, url, SourceTypeConstant.AS400)
        .subscribe((response :MemberSearchByFboIdResponse) => {
            this.accountSearchResponse(response, true);
            if(response && response.fboSearchResultModelList && response.fboSearchResultModelList.length){
                const distributorID = response.fboSearchResultModelList[0].fboId;   
                this.getAccountStatus(distributorID);
            }
        }, error => {
            this.searchErrorResponse(error);
        }, () => {
            this.isLoading = false;
        });
    }

    getAccountStatus(distributorID){
        this._commonService.getMemberStatus(distributorID).subscribe(response => {
            if(response){
                this.accountStatus = response.status;
            } else {
                this.accountStatus = null;
            }
        })
    }
    /**
     *
     *
     * @param {*} error
     * @memberof SearchComponent
     */
    searchErrorResponse(error: any) {
        this.isLoading = false;
        this.isSearchCancelled = false;
        this.pageCount = 0;
        if (error.validations && error.validations.length > 0) {
            this._commonService.setNotification("", error.validations[0].message, "error", 0, true, 30);
        }
    }

    /**
     * @description get details based on GovernmentID/SSN
     * @date 2019-06-26
     * @param {string} [url]
     * @memberof SearchComponent
     */
    accountSearchResponse(response: any, searchByFboId: boolean): void {
        if (!response) {
            this.isLoading = false;
            this.isSearchCancelled = false;
            this.pageCount = 0;
        } else if (this.searchRequest.searchBy === Constants.MEMBER) {
            if (searchByFboId) {
                if (response.status === SearchResponseType.COMPLETED
                    && response.fboSearchResultModelList && response.fboSearchResultModelList.length > 0) {
                    this.searchSuccess(response);
                } else {
                    this.searchPolling(response);
                }
            } else {
                this.searchSuccess(response);
            }
        } else if (this.searchRequest.searchBy === Constants.ORDER) {
            if (response.orderModelList && response.orderModelList.length > 0) {
                this.searchSuccess(response);
            }
        }

    }

    searchSuccess(response): void {
        if (response && !this.isSearchCancelled) {
            this.isLoading = false;
            this.isSearchCancelled = false;
            this.pageCount = response.recordsCount;
            this.searchResponse = response;
            // As we not recieving Order Group ID from As400 for implementing permission
            this.hasRegularOrderViewPermission = true;
            if (!this.searchResponse.fboSearchResultModelList) {
                this.searchResponse.fboSearchResultModelList = new Array<FBOResponse>();
            }
            if (!this.searchResponse.customerResultModelList) {
                this.searchResponse.customerResultModelList = new Array<RetailResponse>();
            }
            if (!this.searchResponse.orderModelList) {
                this.searchResponse.orderModelList = new Array<OrderResponse>();
            }
            if (this.searchResponse.orderModelList) {
                this.ordersPageCount = this.searchResponse.orderModelList.length;
                if (this.searchResponse.orderModelList.length > 0) {
                    const countryCodes: string[] = this.searchResponse.orderModelList.map(item => item.country);
                    if (countryCodes && countryCodes.length > 0) {
                        this.getStoreinfo(countryCodes, this.searchResponse.orderModelList, 'search-result');
                    }
                    if (this.orderhistoryPermission && (this.hasRegularOrderViewPermission || this.hasPOSOrderViewPermission)
                     && this.searchResponse.orderModelList.length <= 2) {
                       const orderSearchResult = this.searchResponse.orderModelList[0];
                       this.navigateToOrderDetail(orderSearchResult.fboId, orderSearchResult.fullName, orderSearchResult.orderNumber,
                            orderSearchResult.webOrderNumber, orderSearchResult.country, orderSearchResult.orderType,
                            orderSearchResult.memberType,orderSearchResult.memberLevelID);
                   }
                }
            }
            this.isLoading = false;
            this._cacheService.removeSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
        } else {
            this.pageCount = 0;
            this.searchResponse.orderModelList = new Array<OrderResponse>();
            this.isLoading = false;
            this.isSearchCancelled = false;
            this._cacheService.removeSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
        }
    }
    /**
   * Gets search results
   */
    getOrderSearchResultsBycreditCard() {
        this.isLoading = true;
        this.searchRequest.pageNumber = this.pageNumber;
        this.searchRequest.pageSize = this.pageSize;
        this.searchRequest.sort = this.sortByCreditCard;
        this.searchRequest.sortOrder = [];
        !this.sortByColumn ? this.sortByColumn = 'ORD.DistributorID' : '';
        this.searchRequest.sortOrder.push(this.sortByColumn);
        this.searchRequest.isAdvancedSearch = !this.isAdvancedSearch;
        this.searchRequest.searchAccountUsingAlternativeLanguage = false;
        this.searchSubscription = this._customerservice.getOrderSearchResultsByCreditCard(this.searchRequest).subscribe(response => {
            this.searchResponse.orderModelList = new Array<OrderResponse>();
            if (response && !this.isSearchCancelled) {
                this.isSearchCancelled = false;
                this.isFromTitan = true;
                !this.ordersPageCount ? this.ordersPageCount = response.totalCount : '';
                if (!this.searchResponse.fboSearchResultModelList) {
                    this.searchResponse.fboSearchResultModelList = new Array<FBOResponse>();
                }
                if (!this.searchResponse.customerResultModelList) {
                    this.searchResponse.customerResultModelList = new Array<RetailResponse>();
                }

                this.searchResponse.orderModelList = new Array<OrderResponse>();

                if (response.content && response.content.length > 0) {
                    const countryCodes: string[] = response.content.map(item => item.countryCode);
                    if (countryCodes && countryCodes.length > 0) {
                        this.getStoreinfo(countryCodes, response.content, 'credit-card');
                    }
                }
                this.resetAlternativeLanguageSearchField();
            } else {
                this.isFromTitan = false;
                this.isLoading = false;
                this.isSearchCancelled = false;
                this.ordersPageCount = 0;
                this.searchResponse.orderModelList = new Array<OrderResponse>();
                this.resetAlternativeLanguageSearchField();
            }
        }, error => {
            this.isLoading = false;
            this.isSearchCancelled = false;
            this.ordersPageCount = 0;
            this.resetAlternativeLanguageSearchField();
        }, () => {
            setTimeout(function () {
                this.isLoading = false;
            }, 2000);
        });
    }

    getStoreinfo(countryCodes: string[], content, flow: string) {
        countryCodes = countryCodes.filter(function (item, pos) {
            return countryCodes.indexOf(item) === pos;
        })
        this._customerservice.getStoreInfo(countryCodes).subscribe((data: any) => {
            if (data && data.length > 0) {
                this.setOrderInfo(content, data, flow);
            }
        }
        );
    }

    setOrderInfo(content, storeInformation, flow: string): void {
        let navigateToOrderDetail = false;
        if (flow === 'credit-card') {
            content.forEach((item: any) => {
                const order = new OrderResponse();
                order.fboId = item.distributorId;
                order.webOrderNumber = item.webOrderId;
                order.orderNumber = item.systemOrderNumber;
                order.fullName = item.fullName;
                if (item && item.shipToName) {
                    order.shipToName = item.shipToName;
                } else {
                    order.shipToName = (item.firstName ? item.firstName : '') + ' ' +
                        (item.middleName ? item.middleName : '') + ' ' + (item.lastName ? item.lastName : '');
                }
                order.orderSource = item.source;
                order.orderType = item.orderTypeName;
                order.orderTypeId = item.orderTypeId;
                order.country = item.countryCode;
                const storeInfo = storeInformation.find(info => info.homeCountryCode === item.countryCode);
                const timeZoneOffset = storeInfo && storeInfo.timeZoneOffset ? storeInfo.timeZoneOffset : -6;
                order.orderDate = item.backDateOrder ? moment.utc(item.orderPostedDate).utcOffset(item.storePostedOffset).format('DD-MMM-YYYY') : moment.utc(item.orderPlacedDate).utcOffset(item.storePostedOffset).format('DD-MMM-YYYY');
                order.status = item.orderStatus;
                order.orderGroupId = item.orderGroupId;
                this.searchResponse.orderModelList.push(order);
            });
        } else if (flow === 'web-order') {
            this.searchResponse.orderModelList = [];
            content.forEach((item: any) => {
            const orderResponse = new OrderResponse();
            orderResponse.fboId = item.distributorId;
            orderResponse.webOrderNumber = item.webOrderId;
            const storeInfo = storeInformation.find(info => info.homeCountryCode === item.countryCode);
            const timeZoneOffset = storeInfo && storeInfo.timeZoneOffset ? storeInfo.timeZoneOffset : -6;
            orderResponse.orderDate = item.backDateOrder ? moment.utc(item.orderPostedDate).utcOffset(item.storePostedOffset).format('DD-MMM-YYYY') : moment.utc(item.orderPostedDate).utcOffset(item.storePostedOffset).format('DD-MMM-YYYY');
            orderResponse.status = item.orderStatus;
            orderResponse.orderNumber = item.systemOrderNumber;
            orderResponse.orderGroupId = item.orderGroupId;
            orderResponse.memberLevelID = item.memberLevelID;
            if (item.orderTypeId === PurchaseFlow.Enrollment) {
                orderResponse.orderType = StatusConstants.Enrollment;
            } else if (item.orderTypeId === PurchaseFlow.Personal_Order) {
                orderResponse.orderType = StatusConstants.Personal;
            } else if (item.orderTypeId === PurchaseFlow.Retail) {
                orderResponse.orderType = StatusConstants.Retail;
            } else if (item.orderTypeId === OrderType.SERVICE_ORDER) {
                orderResponse.orderType = Constants.SERVICE_ORDER;
            }
            orderResponse.orderSource = item.source;
            if(item.fullName){
                orderResponse.fullName = item.fullName;
            }
            else{
                this._orderservice.getMemberInfo(item.distributorId, 'fboId').subscribe(res => {
                    if (res && res.memberId) {
                        orderResponse.fullName = res.firstName + ' ' + res.lastName;
                        if (this.searchResponse && this.searchResponse.orderModelList && this.searchResponse.orderModelList.length > 0
                            && this.orderhistoryPermission && (this.hasRegularOrderViewPermission || this.hasPOSOrderViewPermission)) {
                            this.navigateToOrderView();
                            navigateToOrderDetail = true;
                        }
                    }
            });
            }
            if (item.shipToName) {
                orderResponse.shipToName = item.shipToName;
            } else {
                orderResponse.shipToName = (item.firstName ? item.firstName : '')
                    + ' ' + (item.middleName ? item.middleName : '') + ' ' + (item.lastName ? item.lastName : '');
            }
            orderResponse.country = item.countryCode;
            this.searchResponse.orderModelList.push(orderResponse);
        });
        if (this.searchResponse && this.searchResponse.orderModelList && this.searchResponse.orderModelList.length <= 2
                    && this.orderhistoryPermission && (this.hasRegularOrderViewPermission || this.hasPOSOrderViewPermission)) {
                   const orderSearchResult = this.searchResponse.orderModelList[0];
                   this.navigateToOrderDetail(orderSearchResult.fboId, orderSearchResult.fullName, orderSearchResult.orderNumber,
                        orderSearchResult.webOrderNumber, orderSearchResult.country, orderSearchResult.orderType,
                        orderSearchResult.memberType,orderSearchResult.memberLevelID);
               }
        this.ordersPageCount = this.searchResponse.orderModelList.length;
        } else {
            content.forEach((orderData: any) => {
                const storeInfo = storeInformation.find(info => info.homeCountryCode === orderData.country);
                const timeZoneOffset = storeInfo && storeInfo.timeZoneOffset ? storeInfo.timeZoneOffset : -6;
                orderData.orderDate = moment(new Date(orderData.orderDate)).format('DD-MMM-YYYY');
                // As we not recieving Order Group ID from As400 for implementing permission
                orderData.orderGroupId = this.orderGroup.REGULAR;
            });
            this.searchResponse.orderModelList = content;
        }
        this.isLoading = false;
        if (!navigateToOrderDetail && this._cacheService.getSessionValue(CacheKey.ORDER_INFO_SESSION_CODE)) {
            this.navigateToOrderView();
            this._cacheService.removeSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
        }

    }

    private navigateToOrderView(): void {
        this._cacheService.removeSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
        const orderSearchResult = this.searchResponse.orderModelList[0];
        this.navigateToOrderDetail(orderSearchResult.fboId, orderSearchResult.fullName?orderSearchResult.fullName:orderSearchResult.shipToName, orderSearchResult.orderNumber,
            orderSearchResult.webOrderNumber, orderSearchResult.country, orderSearchResult.orderType,
            orderSearchResult.memberType,orderSearchResult.memberLevelID);
    }


    /** * HITS SERVICES   ----- END ----- ***************** */

    /**
     * to view advanced options
     */
    onAdvancedSearchClick() {
        this.isSearch = false;
        this.clearRecentlyViewedDetails();
        const adminContent = document.getElementById('admin-content');
        if (adminContent) {
            this.searchScreenWidth = adminContent.offsetWidth;
        }
        this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
        if (this.customerSearchModel.searchKeyInput) {
            this.bindValuesToAdvancedSearchFields();
        }
        this.isAdvancedSearch = true;  // View advanced search

        this.customerSearchModel.searchKey = '';
        this.customerSearchModel.searchKeyInput = "";
    }

    /**
     * bind basic search values to advanced search fields.
     */
    bindValuesToAdvancedSearchFields() {
        var numericFormat = /^[0-9]+$/;
        var emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        var characterFormat = /^[a-zA-Z]+$/;
        this.customerSearchModel.searchKeyInput = this.customerSearchModel.searchKeyInput.trim();
        var isNumeric = numericFormat.test(this.customerSearchModel.searchKeyInput);
        var isOnlyCharacters = characterFormat.test(this.customerSearchModel.searchKeyInput);
        var isEmail = emailFormat.test(this.customerSearchModel.searchKeyInput);
        if (this.customerSearchModel.searchBy === Constants.FBO) {
            if (!isNumeric) {
                this.customerSearchModel.firstName = this.customerSearchModel.searchKeyInput;
                this.customerSearchModel.lastName = this.customerSearchModel.searchKeyInput;
            }
            else {
                this.customerSearchModel.fboId = this.customerSearchModel.searchKeyInput;
            }
        }
        else if (this.customerSearchModel.searchBy === Constants.Retail) {
            if (isEmail) {
                this.customerSearchModel.email = this.customerSearchModel.searchKeyInput;
            }
            else {
                this.customerSearchModel.userName = this.customerSearchModel.searchKeyInput;
            }
        }
        else if (this.customerSearchModel.searchBy === Constants.Retail_Orders) {
            if (isOnlyCharacters) {
                this.customerSearchModel.userName = this.customerSearchModel.searchKeyInput;
            }
            else {
                this.customerSearchModel.orderNumber = this.customerSearchModel.searchKeyInput;
            }
        }
        else {
            this.customerSearchModel.orderNumber = this.customerSearchModel.searchKeyInput;
        }
    }

    /**
     *  to view basic options
     */
    onBasicSearchClick() {
        this.isSearch = false;
        this.clearRecentlyViewedDetails();
        const adminContent = document.getElementById('admin-content');
        if (adminContent) {
            this.searchScreenWidth = adminContent.offsetWidth;
        }
        this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
        this.customerSearchModel.searchKeyInput = '';
        //newly added statement
        // if (!(this.customerSearchModel.searchKey.constructor === Array)) {
        //     this.customerSearchModel.searchKey = new Array<String>();
        // }
        this.bindValuesToBasicFields();
        this.isAdvancedSearch = false;   // view basic search
    }

    /**
     * bind values to basic search field when navigating from advanced to basic
     */
    bindValuesToBasicFields() {
        var numericFormat = /^[0-9]+$/;
        var emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        var characterFormat = /^[a-zA-Z]+$/;

        if (this.customerSearchModel.searchBy === Constants.FBO) {
            this.customerSearchModel.searchKeyInput = this.customerSearchModel.fboId ? this.customerSearchModel.fboId : (this.customerSearchModel.firstName ? this.customerSearchModel.firstName : (this.customerSearchModel.lastName ? this.customerSearchModel.lastName : ''));
            if (this.customerSearchModel.searchKeyInput && this.customerSearchModel.searchKeyInput !== '') {
                var isNumeric = numericFormat.test(this.customerSearchModel.searchKeyInput);
                this.customerSearchModel.searchKey = isNumeric ? this.fieldTypes.FBOID : (this.customerSearchModel.firstName ? this.fieldTypes.FIRSTNAME : this.fieldTypes.LASTNAME);
            }
        }
        else if (this.customerSearchModel.searchBy === Constants.Retail) {
            this.customerSearchModel.searchKeyInput = this.customerSearchModel.userName ? this.customerSearchModel.userName : (this.customerSearchModel.email ? this.customerSearchModel.email : '');
            if (this.customerSearchModel.searchKeyInput && this.customerSearchModel.searchKeyInput !== '') {
                var isEmail = emailFormat.test(this.customerSearchModel.searchKeyInput);
                this.customerSearchModel.searchKey = isEmail ? this.fieldTypes.EMAILADDRESS : this.fieldTypes.USERNAME;
            }
        }
        else if (this.customerSearchModel.searchBy === Constants.Retail_Orders) {
            this.customerSearchModel.searchKeyInput = this.customerSearchModel.userName ? this.customerSearchModel.userName : (this.customerSearchModel.orderNumber ? this.customerSearchModel.orderNumber : '');
            if (this.customerSearchModel.searchKeyInput && this.customerSearchModel.searchKeyInput !== '') {
                var isOnlyCharacters = characterFormat.test(this.customerSearchModel.searchKeyInput);
                this.customerSearchModel.searchKey = isOnlyCharacters ? this.fieldTypes.USERNAME : this.fieldTypes.ORDERNUMBER;
            }
        }
        else {
            this.customerSearchModel.searchKeyInput = this.customerSearchModel.orderNumber ? this.customerSearchModel.orderNumber : '';
            this.customerSearchModel.searchKey = this.fieldTypes.ORDERNUMBER;

        }
    }

    /**
     * On country change
     */
    onCountryChange() {
        if (this.customerSearchModel.homeCountry && this.customerSearchModel.homeCountry !== "undefined") {
            this.disableState = false;
            this.getStatesByCountry(this.customerSearchModel.homeCountry);

        } else {
            this.disableState = true;
        }
    }

    /**
     * On Page change
     * @param pageNumber
     */
    pageChange(pageNumber: number) {
        this.pageNumber = pageNumber;
        if (+this.searchType === this.distributorEnum[3])
            this.getOrderSearchResultsBycreditCard();
        else
            this.getSearchResults();
    }

    /**
     * sort table by respective column
     * @param sortColumn
     */
    sortTableByColumn(sortColumn: string) {
        //added this condition not to hit service if there are no items in grid.
        if ((this.customerSearchModel.searchBy === Constants.MEMBER && this.searchResponse.fboSearchResultModelList.length === 0)
            || ((this.customerSearchModel.searchBy === Constants.ORDER)
                && this.searchResponse.orderModelList.length === 0)) {
            return;
        }
        this.pageNumber = 1;
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? "DESC" : "ASC";
        this.sortColumn = sortColumn;
        if (!(+this.searchType === this.distributorEnum[3])) {
            this.getSearchResults();
        }
        else {
            this.searchRequest.sortOrder = [];
            this.searchRequest.sortOrder.push(this.sortColumn);
            this.getOrderSearchResultsBycreditCard();
        }
    }

    onSearch() {
        this.updatePaginationVariables();
        this.getSearchResponseInstance();
        const adminContent = document.getElementById('admin-content');
        if (adminContent) {
            this.searchScreenWidth = adminContent.offsetWidth;
        }
        this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
        if (this.customerSearchModel.orderNumber || this.customerSearchModel.fboId
            || this.customerSearchModel.firstName || this.customerSearchModel.lastName) {
            if ((this.customerSearchModel.firstName || this.customerSearchModel.lastName)
                && !(this.customerSearchModel.orderNumber || this.customerSearchModel.fboId)) {
                if (!this.customerSearchModel.homeCountry || this.customerSearchModel.homeCountry === "undefined") {
                    this.isSearch = true;
                    this.showMandatoryValidationMessage = false;
                    this.showHomeCountryValidationMessage = true;
                    // hiding of grids...
                    this.fboPanelGrid = false;
                    this.fboOrderPanelGrid = false;
                    return;
                }
            }
            if (this.customerSearchModel.orderNumber || this.customerSearchModel.fromDate
                || this.customerSearchModel.toDate || this.customerSearchModel.fourDigitSSN) {

                this.customerSearchModel.searchBy = Constants.ORDER;

            } else if (this.customerSearchModel.fboId || this.customerSearchModel.lastName
                || this.customerSearchModel.firstName || this.customerSearchModel.email || this.customerSearchModel.phoneNumber
                || this.customerSearchModel.homeCountry || this.customerSearchModel.city || this.customerSearchModel.middleName
                || this.customerSearchModel.memberType || this.customerSearchModel.memberLevel || this.customerSearchModel.sponsor) {

                this.customerSearchModel.searchBy = Constants.MEMBER;

            }

        } else {
            this.isSearch = true;
            this.showMandatoryValidationMessage = true;
            this.showHomeCountryValidationMessage = false;
            // hiding of grids...
            this.fboPanelGrid = false;
            this.fboOrderPanelGrid = false;
            return;
        }
        if (this.customerSearchModel.searchBy === Constants.MEMBER) {
            this.isSearch = false;
            this.fboOrderPanelGrid = false;
            this.fboPanelGrid = true;
        } else {
            this.isSearch = false;
            this.fboOrderPanelGrid = true;
            this.fboPanelGrid = false;

        }
        if (!this.isSearch) {
            this.buildSearchRequest();
        }
        this.recentSearch = this.customerSearchModel;
        this._cacheService.set(this.recentSearchKey, this.recentSearch);
    }


    onCancelSearch() {
        this.searchSubscription.unsubscribe();
        this.isLoading = false;
    }
    resetSearch() {
        this.getCustomerSearchInstance();
    }
    /**
     * Clear advanced search fields on click of Basic level search
     */
    clearAdvancedFields() {
        var searchBy = this.customerSearchModel.searchBy;
        var searchKey = this.customerSearchModel.searchKey;
        var searchKeyInput = this.customerSearchModel.searchKeyInput;
        this.customerSearchModel = new SearchModel();
        this.customerSearchModel.searchBy = searchBy;
        this.customerSearchModel.searchKey = searchKey;
        this.customerSearchModel.searchKeyInput = searchKeyInput;
    }
    buildSearchRequest() {

        this.searchCriteriaList = new Array<SearchCriteria>();
        if (this.customerSearchModel.searchBy === Constants.ORDER) {
            if (this.customerSearchModel.orderNumber) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.orderNumber;
                this.searchCriteria.searchKey = this.fieldTypes.ORDERNUMBER;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.fboId) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.fboId;
                this.searchCriteria.searchKey = this.fieldTypes.FBOID;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.fromDate) {

                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.fromDate;
                this.searchCriteria.searchKey = this.fieldTypes.FROMDATE;
                this.searchCriteriaList.push(this.searchCriteria);

            }

            if (this.customerSearchModel.toDate) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.toDate;
                this.searchCriteria.searchKey = this.fieldTypes.TODATE;
                this.searchCriteriaList.push(this.searchCriteria);

            }

            if (this.customerSearchModel.fourDigitSSN) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.fourDigitSSN;
                this.searchCriteria.searchKey = this.fieldTypes.LASTFOURSSNDIGITS;
                this.searchCriteriaList.push(this.searchCriteria);

            }

            if (this.customerSearchModel.homeCountry && this.customerSearchModel.homeCountry !== "undefined") {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.homeCountry;
                this.searchCriteria.searchKey = this.fieldTypes.HOMECOUNTRY;
                this.searchCriteriaList.push(this.searchCriteria);
            }
        }
        if (this.customerSearchModel.searchBy === Constants.MEMBER) {
            if (this.customerSearchModel.fboId) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.fboId;
                this.searchCriteria.searchKey = this.fieldTypes.FBOID;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.firstName) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.firstName;
                this.searchCriteria.searchKey = this.fieldTypes.FIRSTNAME;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.middleName && this.customerSearchModel.middleName !== "undefined") {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.middleName;
                this.searchCriteria.searchKey = this.fieldTypes.MIDDLENAME;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.lastName) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.lastName;
                this.searchCriteria.searchKey = this.fieldTypes.LASTNAME;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.email) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.email;
                this.searchCriteria.searchKey = this.fieldTypes.EMAILADDRESS;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.phoneNumber) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.phoneNumber;
                this.searchCriteria.searchKey = this.fieldTypes.PHONENUMBER;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.homeCountry && this.customerSearchModel.homeCountry !== "undefined") {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.homeCountry;
                this.searchCriteria.searchKey = this.fieldTypes.HOMECOUNTRY;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.state && this.customerSearchModel.state !== "undefined") {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.state;
                this.searchCriteria.searchKey = this.fieldTypes.STATE;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.city && this.customerSearchModel.city !== "undefined") {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.city;
                this.searchCriteria.searchKey = this.fieldTypes.CITY;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.sponsor) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.sponsor;
                this.searchCriteria.searchKey = this.fieldTypes.SPONSORID;
                this.searchCriteriaList.push(this.searchCriteria);
            }
            if (this.customerSearchModel.status) {
                this.searchCriteria = new SearchCriteria();
                this.searchCriteria.searchValue = this.customerSearchModel.status;
                this.searchCriteria.searchKey = this.fieldTypes.STATUS;
                this.searchCriteriaList.push(this.searchCriteria);
            }

        }

        this.searchRequest.searchBy = this.customerSearchModel.searchBy;
        this.searchRequest.searchCriteria = this.searchCriteriaList;

    }
    /**
    * display alert box if the logged in user do not have permission to see the fbo/retail information
    */
    displayAlertbox() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    }
    /**
     * Navigate to FBO Profile page
     * @param id
     */
    closeModal(status: boolean){
            this.accountRestriction = status;
            this.accountStatus ='';
    }

    navigateTOFBOProfileDetail (id: any, memberType: string, name: string, memberLevelID?: any){
        this._commonService.getMemberStatus(id).subscribe(response => {
            if(response){
                this.accountStatus = response.status;
                if(response.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                    this.accountRestriction = true;
                    const memberlevel = this._commonService.getMemberLevel(memberLevelID);
                    const memberDetails = {
                        fboId: id,
                        firstName: name,
                        memberLevel: memberlevel
                    };
                    this.memberDetails = memberDetails; 
                } else {
                    this.navigateToFBOProfile(id,memberType,name);
                }
            } else {
                this.navigateToFBOProfile(id,memberType,name);
                this.accountStatus = null;
            }
        })
    }

    navigateToFBOProfile(id: any, memberType: string, name: string) {
        if(this.accountStatus === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
            this.accountRestriction = true;
            if(this.memberDetails && this.memberDetails.fboSearchResultModelList && this.memberDetails.fboSearchResultModelList.length){
                this.memberDetails = this.memberDetails.fboSearchResultModelList[0];                 
            }
        } else {
            var isAuthorized = this._commonService.checkPermissionByAccessLevel(this.FBODetailPermissions,AccessLevel.Customer_Service);
            if (isAuthorized) {
                let fboInfo = { id: id, tabName: name, componentName: 'fboPage', memberType: memberType };
                    setTimeout(() => {
                      this.messageService.setCustomerServiceTabContent(fboInfo);
                  },300);
            }
            else {
                this.displayAlertbox();
            }
            this._cacheService.removeSessionValue(CacheKey.DistributorInfo);
            this._cacheService.removeSessionValue(CacheKey.FboProfileDetail);
        }
    }

    navigateToOrderDetail(id: any, name: string, orderNumber: string, webOrderNumber: string, country: string, orderType: string, memberType?: string,memberLevelID?: number) {
        this._commonService.getMemberStatus(id).subscribe(response => {
            if(response){
                this.accountStatus = response.status;
                if(response.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                    this.accountRestriction = true;
                    const memberlevel = this._commonService.getMemberLevel(memberLevelID);
                    const memberDetails = {
                        fboId: id,
                        firstName: name,
                        memberLevel: memberlevel
                    };
                    this.memberDetails = memberDetails; 
                } else {
                    var isAuthorized = this._commonService.checkPermissionByAccessLevel(this.FBODetailPermissions,AccessLevel.Customer_Service);
                    if (isAuthorized) {
                        let isNewOrder: boolean;
                        let orderInfo = { id: id, tabName: name, componentName: 'fboPage', memberType: memberType, orderNumber: orderNumber, webOrderNumber: webOrderNumber, country: country, isNewOrder: this.isFromTitan ? 1 : 0, orderType: orderType };
                        this.messageService.setCustomerServiceTabContent(orderInfo);
                    }
                    else {
                        this.displayAlertbox();
                    }
                    this._cacheService.removeSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
                }
            } else {
                var isAuthorized = this._commonService.checkPermissionByAccessLevel(this.FBODetailPermissions,AccessLevel.Customer_Service);
                    if (isAuthorized) {
                        let isNewOrder: boolean;
                        let orderInfo = { id: id, tabName: name, componentName: 'fboPage', memberType: memberType, orderNumber: orderNumber, webOrderNumber: webOrderNumber, country: country, isNewOrder: this.isFromTitan ? 1 : 0, orderType: orderType };
                        this.messageService.setCustomerServiceTabContent(orderInfo);
                    }
                    else {
                        this.displayAlertbox();
                    }
                    this._cacheService.removeSessionValue(CacheKey.ORDER_INFO_SESSION_CODE);
                    this.accountStatus = null;
            }
        })
    }

    /**
      * Navigate to Retail customer profile page
      * @param id
      */
    navigateToRetailProfile(id: any, name: string) {
        // verifying permissions - whether any one of the permission exists for logged in user.
        var isAuthorized = this._commonService.checkPermissionByAccessLevel(this.retailPermissions,AccessLevel.Customer_Service);
        if (isAuthorized) {
            let retailInfo = { id: id, tabName: name, componentName: 'retailPage' };
            this.messageService.setCustomerServiceTabContent(retailInfo);
        }
        else {
            this.displayAlertbox();
        }
    }

    /**
     * Open right side panel
     */
    openRightMenu() {
        const contentWidth = document.getElementById('admin-content').offsetWidth;
        this.viewRightPanel = !this.viewRightPanel;
        if (this.viewRightPanel) {
            this.searchScreenWidth = contentWidth - 260;
        } else {
            if ((contentWidth - 260) == this.searchScreenWidth) {
                this.searchScreenWidth = contentWidth;
            }
        }
        this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
        if (!this.recentDetailsResponse.fboUsers || this.recentDetailsResponse.fboUsers.length === 0
            || !this.recentDetailsResponse.retailUsers || this.recentDetailsResponse.retailUsers.length === 0
            || !this.recentDetailsResponse.preferredUsers || this.recentDetailsResponse.preferredUsers.length === 0) {
            this.getRecentSearchDetails(this.userId);
        }

    }

    /**
     * On change of date value
     * @param date
     * @param valueToChange
     */
    onDateChange(date: any, valueToChange: string): any {
        if (valueToChange === 'fromDate') {
            this.customerSearchModel.fromDate = date;
        } else if (valueToChange === 'toDate') {
            this.customerSearchModel.toDate = date;
        }
    }


    setCurrentDate(): void {
        const date = new Date().toJSON().split('T')[0];

    }
    /**
     * date to be cleared...
     * @param valueToClear
     */
    onDateClear(valueToClear: string): void {
        if (valueToClear === 'fromDate') {
            this.customerSearchModel.fromDate = '';
        } else if (valueToClear === 'toDate') {
            this.customerSearchModel.toDate = '';
        }
    }

    /**
     * close recently viewed panel
     */
    closeRecentlyViewedPanel() {
        if (this.focusMemberName && this.focusMemberName.nativeElement) {
            this.focusMemberName.nativeElement.focus();
        }
        this.viewRightPanel = false;
        const adminContent = document.getElementById('admin-content');
        if (adminContent) {
            this.searchScreenWidth = adminContent.offsetWidth;
        }
        this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
    }

    /**
     * Close all opened tabs // hits the method present in DynamicTabsComponent
     */
    closeOpenedTabs() {
        this.messageService.setCloseTabsEvent(true);
    }

    /**
      * on load creates Search Form
      */
    createForm(deafultfocus: boolean, selectedSearchType?: any) {
        if((+selectedSearchType === this.distributorEnum[1] || +selectedSearchType === this.distributorEnum[2])
            && (!this.countries || !this.searchByOrderCountries)) {
            this.getCountries();
        }

        if (selectedSearchType) {
            this.selectedSearchType = selectedSearchType;
        }
        this.searchForm = this._formbuilder.group(
            {
                searchCriteria: [this.searchForm && this.searchForm.controls['searchCriteria'].value ? this.searchForm.controls['searchCriteria'].value : DistributorSearchEnums.By_Member.toString()],
                memberInfo: [''],
                memberPhone: [''],
                memberEmail: [''],
                firstName: [''],
                middleName: [''],
                lastName: [''],
                state: [],
                city: [''],
                country: [''],
                //zipCode: [''],
                orderInfo: [''],
                creditCardNumber: [''],
                fromDate: [''],
                toDate: [''],
                memberGovtInfo: [''],
                searchByOrderCountry: [''],
                alternativeLanguageSearch :[false]
            });
        this.addValidationsToFields(deafultfocus);
    }
    addValidationsToFields(deafultfocus: boolean) {
        this.invalidToDate = false;
        this.isSubmitted = false;
        if (+this.searchType === this.distributorEnum[0]) {
            if (deafultfocus) {
                setTimeout(() => {
                    const memberInfoInput = document.getElementById('memberIDInput');
                    if (memberInfoInput) {
                        memberInfoInput.focus();
                    }
                }, 200);
            }
            this.memberInfoTabIndex = 2;
            this.byCardTabIndex = 1;
            this.byOrderTabIndex = 1;
            this.byNameTabIndex = 1;
            this.searchForm.controls['memberInfo'].setValidators([Validators.required, Utils.searchByMemberValidation]);
            this.searchForm.controls['memberInfo'].updateValueAndValidity();
            // added null check for iPad crashed issue
            const memberInfoBlock = document.getElementById('memberInfoBlock');
            const memberCCBlock = document.getElementById('memberCCBlock');
            const memberOrderBlock = document.getElementById('memberOrderBlock');
            const memberNameBlock = document.getElementById('memberNameBlock');
            if (memberInfoBlock) {
                memberInfoBlock.classList.add('show');
                memberInfoBlock.classList.remove('hide');
            }
            if (memberCCBlock) {
                memberCCBlock.classList.remove('show');
                memberCCBlock.classList.add('hide');
            }
            if (memberOrderBlock) {
                memberOrderBlock.classList.remove('show');
                memberOrderBlock.classList.add('hide');
            }
            if (memberNameBlock) {
                memberNameBlock.classList.remove('show');
                memberNameBlock.classList.add('hide');
            }
            // window.document.getElementById("memberCCBlock").classList.remove('show');
            // window.document.getElementById("memberOrderBlock").classList.remove('show');
            // window.document.getElementById("memberNameBlock").classList.remove('show');
            // window.document.getElementById("memberCCBlock").classList.add('hide');
            // window.document.getElementById("memberOrderBlock").classList.add('hide');
            // window.document.getElementById("memberNameBlock").classList.add('hide');
        } else if (+this.searchType === this.distributorEnum[1]) {
            setTimeout(() => {
                const byNameInput = document.getElementById('byNameInput');
                if (byNameInput) {
                    byNameInput.focus();
                }
            }, 200);
            this.memberInfoTabIndex = 1;
            this.byCardTabIndex = 1;
            this.byOrderTabIndex = 1;
            this.byNameTabIndex = 2;
            this.searchForm.controls['firstName'].setValidators([Validators.required,Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]);
            this.searchForm.controls['firstName'].updateValueAndValidity();
            this.searchForm.controls['lastName'].setValidators([Validators.required,Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]);
            this.searchForm.controls['lastName'].updateValueAndValidity();
            this.searchForm.controls['country'].setValidators([Validators.required]);
            this.searchForm.controls['country'].updateValueAndValidity();
            if (this.countries && this.countries.length) {
                const countryInfo = this.countries.find((country: any) => country && country.value
                    && country.value.toLowerCase() === OperatingCountryEnums[OperatingCountryEnums.USA].toLowerCase());
                if (countryInfo) {
                    this.searchForm.controls['country'].setValue(countryInfo.id);
                    this.searchForm.controls['country'].updateValueAndValidity();
                }
            }
            if (this.searchForm.controls['country'].value) {
                this.getStatesByCountry(this.searchForm.controls['country'].value);
            }
            // added null check for iPad crashed issue
            const memberInfoBlock = document.getElementById('memberInfoBlock');
            const memberNameBlock = document.getElementById('memberNameBlock');
            if (memberInfoBlock) {
                memberInfoBlock.classList.remove('show');
                memberInfoBlock.classList.add('hide');
            }
            if (memberNameBlock) {
                memberNameBlock.classList.remove('hide');
            }
            // window.document.getElementById("memberInfoBlock").classList.remove('show');
            // window.document.getElementById("memberInfoBlock").classList.add('hide');
            // window.document.getElementById("memberNameBlock").classList.remove('hide');
        } else if (+this.searchType === this.distributorEnum[2]) {
            setTimeout(() => {
                const byOrderInput = document.getElementById('byOrderInput');
                if (byOrderInput) {
                    byOrderInput.focus();
                }
            }, 200);
            this.memberInfoTabIndex = 1;
            this.byCardTabIndex = 1;
            this.byOrderTabIndex = 2;
            this.byNameTabIndex = 1;
            this.searchForm.controls['orderInfo'].setValidators([Validators.required]);
            this.searchForm.controls['orderInfo'].updateValueAndValidity();
            this.searchForm.controls['memberInfo'].setValidators([]);
            this.searchForm.controls['memberInfo'].updateValueAndValidity();
            const selectedCountry = { id: 0, name: this.fieldTypes.ALL, value: this.fieldTypes.ALL };
            if (this.searchByOrderCountries) {
                const countryInfo = this.searchByOrderCountries.find((country: any) => country && country.value
                    && country.value.toLowerCase() === selectedCountry.value.toLowerCase());
                if (countryInfo) {
                    this.searchForm.controls['searchByOrderCountry'].setValue(countryInfo.id);
                }
                this.searchForm.controls['searchByOrderCountry'].updateValueAndValidity();
            }
            const memberInfoBlock = document.getElementById('memberInfoBlock');
            const memberOrderBlock = document.getElementById('memberOrderBlock');
            if (memberInfoBlock) {
                memberInfoBlock.classList.remove('show');
                memberInfoBlock.classList.add('hide');
            }
            if (memberOrderBlock) {
                memberOrderBlock.classList.remove('hide');
            }
            // window.document.getElementById("memberInfoBlock").classList.remove('show');
            // window.document.getElementById("memberInfoBlock").classList.add('hide');
            // window.document.getElementById("memberOrderBlock").classList.remove('hide');
        } else if (+this.searchType === this.distributorEnum[3]) {
            setTimeout(() => {
                const byLast4Input = document.getElementById('byLast4Input');
                if (byLast4Input) {
                    byLast4Input.focus();
                }
            }, 200);
            this.memberInfoTabIndex = 1;
            this.byCardTabIndex = 2;
            this.byOrderTabIndex = 1;
            this.byNameTabIndex = 1;
            const memberInfoBlock = document.getElementById('memberInfoBlock');
            const memberCCBlock = document.getElementById('memberCCBlock');
            if (memberCCBlock) {
                memberCCBlock.classList.remove('hide');
            }
            if (memberInfoBlock) {
                memberInfoBlock.classList.remove('show');
                memberInfoBlock.classList.add('hide');
            }
            // window.document.getElementById("memberCCBlock").classList.remove('hide');
            // window.document.getElementById("memberInfoBlock").classList.remove('show');
            // window.document.getElementById("memberInfoBlock").classList.add('hide');
            this.searchForm.controls['creditCardNumber'].setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Utils.numericCharacterValidation]);
            this.searchForm.controls['creditCardNumber'].updateValueAndValidity();
            this.searchForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate()]);
            this.searchForm.controls['fromDate'].updateValueAndValidity();
            this.searchForm.controls['toDate'].setValidators([Utils.validateToDate()]);
            this.searchForm.controls['toDate'].updateValueAndValidity();

        }
    }
    onKeypress(event: any, controlName: string) {
        if (controlName === "creditCardNumber") {
            this.searchForm.controls['fromDate'].setValidators([Utils.validateFromDate()]);
            this.searchForm.controls['fromDate'].updateValueAndValidity();
        } else if (controlName === "fromDate") {

            this.searchForm.controls['creditCardNumber'].setValidators([Validators.minLength(4), Validators.maxLength(4), Utils.numericCharacterValidation]);
            this.searchForm.controls['creditCardNumber'].updateValueAndValidity();
        }
        if (event.keyCode != 8) {
            let value: any = (event.key ? event.key : "");
            let pattern = /^[0-9]*$/;
            if (!new RegExp(pattern).test(value)) {
                event.preventDefault();
            }
        }
    }
    search() {
        this.accountRestriction=false;
        this.searchComponentSettings = new SearchSettingsModal(9, 0);
        const searchBtn = window.document.getElementById('search-button');
        if (searchBtn) {
            searchBtn.classList.add('button-active');
        }
        setTimeout(() => {
            if (searchBtn) {
                searchBtn.classList.remove('button-active');
            }
        }, 1000);
        this.isSubmitted = true;
        if (+this.searchType === this.distributorEnum[3]) {
            this.searchReqValues = this.searchForm.getRawValue();

            if (!this.searchReqValues ||
                (this.searchReqValues && this.searchReqValues.creditCardNumber === '' && (this.searchReqValues.fromDate === '' || this.searchReqValues.fromDate === null))) {
                this.searchForm.controls['creditCardNumber'].setValidators
                    ([Validators.required, Validators.minLength(4), Validators.maxLength(4), Utils.numericCharacterValidation]);
                this.searchForm.controls['creditCardNumber'].updateValueAndValidity();
                this.searchForm.controls['fromDate'].setValidators([Validators.required, Utils.validateFromDate()]);
                this.searchForm.controls['fromDate'].updateValueAndValidity();
            }
            else if (this.searchReqValues && this.searchReqValues.creditCardNumber === '' && this.searchReqValues.fromDate) {
                this.searchForm.controls['creditCardNumber'].setValidators([]);
                this.searchForm.controls['creditCardNumber'].updateValueAndValidity();
                this.searchForm.controls['toDate'].setValidators([Validators.required]);
                this.searchForm.controls['toDate'].updateValueAndValidity();
            }
            else if (this.searchReqValues && this.searchReqValues.creditCardNumber === '' && this.searchReqValues.toDate) {
                this.searchForm.controls['creditCardNumber'].setValidators([]);
                this.searchForm.controls['creditCardNumber'].updateValueAndValidity();
                this.searchForm.controls['fromDate'].setValidators([Validators.required]);
                this.searchForm.controls['fromDate'].updateValueAndValidity();
            }
            else if (this.searchReqValues && this.searchReqValues.creditCardNumber) {
                if (this.searchReqValues.toDate && (this.searchReqValues.fromDate === '' || this.searchReqValues.fromDate === null)) {
                    this.searchForm.controls['creditCardNumber'].setValidators([]);
                    this.searchForm.controls['creditCardNumber'].updateValueAndValidity();
                    this.searchForm.controls['fromDate'].setValidators([Validators.required]);
                    this.searchForm.controls['fromDate'].updateValueAndValidity();
                }
                else if (this.searchReqValues.fromDate && (this.searchReqValues.toDate === '' || this.searchReqValues.toDate === null)) {
                    this.searchForm.controls['creditCardNumber'].setValidators([]);
                    this.searchForm.controls['creditCardNumber'].updateValueAndValidity();
                    this.searchForm.controls['toDate'].setValidators([Validators.required]);
                    this.searchForm.controls['toDate'].updateValueAndValidity();
                }
                else if (this.searchReqValues.fromDate == null && this.searchReqValues.fromDate == null) {
                    this.searchForm.controls['fromDate'].setValidators([]);
                    this.searchForm.controls['fromDate'].updateValueAndValidity();
                    this.searchForm.controls['toDate'].setValidators([]);
                    this.searchForm.controls['toDate'].updateValueAndValidity();
                }
            }

        }

        if (this.searchForm.valid && !this.invalidToDate) {

            // window.document.getElementById("search-button").classList.add('button-active');
            this.searchReqValues = this.searchForm.getRawValue();
            this.searchCriteriaList = new Array<SearchCriteria>();
            if (+this.searchType === this.distributorEnum[0]) {
                this.memberInfoBlurEvent();
                this.searchRequest.searchBy = Constants.MEMBER;
                this.searchReqValues = this.searchForm.getRawValue();
                const distributorIdPattern = /^\d\d\d-\d\d\d-\d\d\d-\d\d\d$/;
                const emailPattern = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
                const phoneNumberPattern = /^[0-9]{10}$/;
                const phoneNumberPattern2 = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
                this.searchCriteria = new SearchCriteria();

                if(this.searchReqValues.memberInfo){
                    let fboId = this.searchReqValues.memberInfo;
                    fboId = fboId.replace(/-|\s/g, "");
                    this.searchCriteria.searchKey = this.fieldTypes.FBOID;
                    this.searchCriteria.searchValue = fboId;
                }
                else if (this.searchReqValues.memberEmail) {
                    this.searchCriteria.searchKey = this.fieldTypes.EMAILADDRESS;
                    this.searchCriteria.searchValue = this.searchReqValues.memberEmail;
                } else if (this.searchReqValues.memberPhone) {
                    this.searchCriteria.searchKey = this.fieldTypes.PHONENUMBER;
                    this.searchCriteria.searchValue = this.searchReqValues.memberPhone.replace(/[^0-9]+/g, '');
                }
                if (this.searchCriteria.searchKey) {
                this.searchCriteriaList.push(this.searchCriteria);
                }
            }
            else if (+this.searchType === this.distributorEnum[1]) {
                this.searchRequest.searchBy = Constants.MEMBER;
                if (this.searchReqValues.firstName) {
                    this.searchCriteria = new SearchCriteria();
                    this.searchCriteria.searchKey = this.fieldTypes.FIRSTNAME;
                    this.searchCriteria.searchValue = this.searchReqValues.firstName.trim();
                    this.searchCriteriaList.push(this.searchCriteria);
                }
                if (this.searchReqValues.middleName) {
                    this.searchCriteria = new SearchCriteria();
                    this.searchCriteria.searchKey = this.fieldTypes.MIDDLENAME;
                    this.searchCriteria.searchValue = this.searchReqValues.middleName.trim();
                    this.searchCriteriaList.push(this.searchCriteria);
                }
                if (this.searchReqValues.lastName) {
                    this.searchCriteria = new SearchCriteria();
                    this.searchCriteria.searchKey = this.fieldTypes.LASTNAME;
                    this.searchCriteria.searchValue = this.searchReqValues.lastName.trim();
                    this.searchCriteriaList.push(this.searchCriteria);
                }
                if (this.searchReqValues.country > 0 ) {
                    this.searchCriteria = new SearchCriteria();
                    this.searchCriteria.searchKey = this.fieldTypes.HOMECOUNTRY;
                    let country = this.countries.find(item => item.id === +this.searchReqValues.country);
                    this.searchCriteria.searchValue = country.value;
                    this.searchCriteriaList.push(this.searchCriteria);
                } else{
                    this.searchCriteria = new SearchCriteria();
                    this.searchCriteria.searchKey = this.fieldTypes.HOMECOUNTRY;
                    this.searchCriteria.searchValue = '';
                    this.searchCriteriaList.push(this.searchCriteria);
                }
                
                if (this.searchReqValues.state) {
                    this.searchCriteria = new SearchCriteria();
                    this.searchCriteria.searchKey = this.fieldTypes.STATE;
                    let state = this.states.find(item => item.id === +this.searchReqValues.state);
                    if (state) {
                        this.searchCriteria.searchValue = state.name;
                        this.searchCriteriaList.push(this.searchCriteria);
                    }
                }
                if (this.searchReqValues.city) {
                    this.searchCriteria = new SearchCriteria();
                    this.searchCriteria.searchKey = this.fieldTypes.CITY;
                    this.searchCriteria.searchValue = this.searchReqValues.city.trim();
                    this.searchCriteriaList.push(this.searchCriteria);
                }

            }
            else if (+this.searchType === this.distributorEnum[2]) {
                this.searchRequest.searchBy = Constants.ORDER;
                if (this.searchReqValues.orderInfo) {
                    this.searchCriteria = new SearchCriteria();
                    this.searchCriteria.searchKey = this.fieldTypes.ORDERNUMBER;
                    this.searchCriteria.searchValue = this.searchReqValues.orderInfo.trim();
                    this.searchCriteria.searchValue = this.searchCriteria.searchValue.toUpperCase();
                    this.searchForm.controls['orderInfo'].setValidators([Validators.required, Validators.pattern("^[a-zA-Z0-9]+$")]);
                    this.searchForm.controls['orderInfo'].updateValueAndValidity();
                    this.searchCriteriaList.push(this.searchCriteria);
                    if (this.searchReqValues.searchByOrderCountry) {
                        this.searchCriteria = new SearchCriteria();
                        this.searchCriteria.searchKey = this.fieldTypes.HOMECOUNTRY;
                        let country = this.countries.find(item => item.id === +this.searchReqValues.searchByOrderCountry);
                        this.searchCriteria.searchValue = country.value;
                        this.searchCriteriaList.push(this.searchCriteria);
                    }
                }
            } else if (+this.searchType === this.distributorEnum[3]) {
                this.searchRequest.searchBy = Constants.ORDER;
                if (this.searchReqValues) {
                    if (this.searchReqValues.creditCardNumber) {
                        const creditCardObject = new SearchCriteria();
                        creditCardObject.searchKey = this.fieldTypes.LASTFOURDIGITSOFCREDITCARD;
                        creditCardObject.searchValue = this.searchReqValues.creditCardNumber;
                        this.searchCriteriaList.push(creditCardObject);
                    }
                    if (this.searchReqValues.fromDate) {
                        this.searchReqValues.fromDate = Utils.convertToSpecificDateFormat(this.searchReqValues.fromDate, DateConstants.DateFormat);
                        const fromDateObject = new SearchCriteria();
                        fromDateObject.searchKey = this.fieldTypes.FROMDATE;
                        fromDateObject.searchValue = this.searchReqValues.fromDate;
                        this.searchCriteriaList.push(fromDateObject);
                    }
                    if (this.searchReqValues.toDate) {
                        this.searchReqValues.toDate = Utils.convertToSpecificDateFormat(this.searchReqValues.toDate, DateConstants.DateFormat);
                        const toDateObject = new SearchCriteria();
                        toDateObject.searchKey = this.fieldTypes.TODATE;
                        toDateObject.searchValue = this.searchReqValues.toDate;
                        this.searchCriteriaList.push(toDateObject);
                    }
                }
            }
            this.isSubmitted = false;
            this.updatePaginationVariables();
            this.getSearchResponseInstance();
            this.searchScreenWidth = window.document.getElementById("admin-content").offsetWidth;
            this.applyMD4Class = this.searchScreenWidth === 834 ? true : false;
            if (this.searchRequest.searchBy === Constants.ORDER) {
                this.fboPanelGrid = false;
                this.fboOrderPanelGrid = true;
            }
            else if (this.searchRequest.searchBy === Constants.MEMBER) {
                this.fboPanelGrid = true;
                this.fboOrderPanelGrid = false;
            }
            this.searchRequest.searchCriteria = this.searchCriteriaList;
            let searchCriteria:any = this.searchRequest.searchCriteria[0];
            if (+this.searchType === this.distributorEnum[3]) {
                this.getOrderSearchResultsBycreditCard();
            }
            else if (+this.searchType === this.distributorEnum[2] && !searchCriteria.searchValue.includes("_")
            && this.searchForm.controls['orderInfo'].valid) {
                this.getOrderByWebOrderId();
            }
            else {
                if (this.searchCriteriaList && this.searchCriteriaList.length) {
                    this.searchComponentSettings.maxPollCount = 9;
                } else {
                    this.searchComponentSettings.maxPollCount = 0;
                }
                this.getSearchResults();
            }
            //  setTimeout(function(){
            //     document.getElementById("orderCancelBtn").focus();
            //  }, 200);
        }

    }

    convertDateToTimeStamp(date: String, isStartDate: Boolean) {

        return null;
    }

    onChangeOfCountry() {
        if (this.searchForm.controls['country'].value >= 0) {
            this.searchForm.controls['state'].setValue(undefined);
            this.searchForm.controls['city'].setValue('');
            if(this.searchForm.controls['country'].value == 0){
                this.states=[];
            }
            else this.getStatesByCountry(this.searchForm.controls['country'].value);
        } else {
            this.states = [];
        }
    }




    transformDate(date: any, isStartDate: boolean) {

        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DateFormat);
        if (dateMomentObj) {
            if (isStartDate && this.searchForm.controls['fromDate'].valid) {
                this.searchForm.controls['fromDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
            if (!isStartDate && this.searchForm.controls['toDate'].valid) {
                this.searchForm.controls['toDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
        }
    }



    /**
     * to prevent space in input field
     */
    onKeydown(event: any) {
        if (event.code === "Space") {
            event.preventDefault();
        }
    }
    /**
     *clear form
     */
    resetForm() {
        this.createForm(false);
    }

    /**
     * @description
     * @date 2019-06-26
     * @param {*} searchType
     * @param {string} formName
     * @memberof SearchComponent
     */
    onFocus(searchType: any, formControlName?: string) {
        if (formControlName === 'memberInfo') {
            this.searchForm.get('memberGovtInfo').setValue('');
            this.searchForm.get('memberEmail').setValue('');
            this.searchForm.get('memberPhone').setValue('');
            this.searchForm.get('memberInfo').markAsUntouched();
            this.searchForm.get('memberInfo').setValidators([Validators.required, Validators.minLength(12)]);
            this.searchForm.get('memberInfo').updateValueAndValidity();
            this.searchForm.get('memberGovtInfo').clearValidators();
            this.searchForm.get('memberGovtInfo').updateValueAndValidity();
            this.searchForm.get('memberEmail').clearValidators();
            this.searchForm.get('memberEmail').updateValueAndValidity();
            this.searchForm.get('memberPhone').clearValidators();
            this.searchForm.get('memberPhone').updateValueAndValidity();
        }
         else if (formControlName === 'memberGovtInfo') {
            this.searchForm.get('memberInfo').setValue('');
            this.searchForm.get('memberEmail').setValue('');
            this.searchForm.get('memberPhone').setValue('');
            this.searchForm.get('memberGovtInfo').setValidators([Validators.required, Validators.minLength(3)]);
            this.searchForm.get('memberGovtInfo').updateValueAndValidity();
            this.searchForm.get('memberInfo').clearValidators();
            this.searchForm.get('memberInfo').updateValueAndValidity();
            this.searchForm.get('memberEmail').clearValidators();
            this.searchForm.get('memberEmail').updateValueAndValidity();
            this.searchForm.get('memberPhone').clearValidators();
            this.searchForm.get('memberPhone').updateValueAndValidity();
        }
        else if (formControlName === 'memberEmail') {
            this.searchForm.get('memberInfo').setValue('');
            this.searchForm.get('memberGovtInfo').setValue('');
            this.searchForm.get('memberPhone').setValue('');
            this.searchForm.get('memberEmail').markAsUntouched();
            this.searchForm.get('memberEmail').setValidators([Validators.required,Utils.emailValidationRule]);
            this.searchForm.get('memberEmail').updateValueAndValidity();
            this.searchForm.get('memberInfo').clearValidators();
            this.searchForm.get('memberInfo').updateValueAndValidity();
            this.searchForm.get('memberGovtInfo').clearValidators();
            this.searchForm.get('memberGovtInfo').updateValueAndValidity();
            this.searchForm.get('memberPhone').clearValidators();
            this.searchForm.get('memberPhone').updateValueAndValidity();
        }
        else if (formControlName === 'memberPhone') {
            this.searchForm.get('memberInfo').setValue('');
            this.searchForm.get('memberGovtInfo').setValue('');
            this.searchForm.get('memberEmail').setValue('');
            const phoneNumberPattern = /^[0-9(\)\+\-\s]*$/;
            this.searchForm.get('memberPhone').setValidators([Validators.required, Validators.pattern(phoneNumberPattern)]);
            this.searchForm.get('memberPhone').updateValueAndValidity();
            this.searchForm.get('memberInfo').clearValidators();
            this.searchForm.get('memberInfo').updateValueAndValidity();
            this.searchForm.get('memberGovtInfo').clearValidators();
            this.searchForm.get('memberGovtInfo').updateValueAndValidity();
            this.searchForm.get('memberEmail').clearValidators();
            this.searchForm.get('memberEmail').updateValueAndValidity();
        }
        if (searchType.toString() !== this.searchType) {
            this.searchType = searchType.toString();
            this.createForm(false);
        }
    }

    OnTabEventRecentlyViewed(event: any, index: any) {

        if (this.recentDetailsResponse.fboUsers && this.recentDetailsResponse.fboUsers.length == index + 1) {
            event.preventDefault();
            this.searchType = DistributorSearchEnums.By_Member.toString();
            this.createForm(true);
        }
    }
    checkValidationForToDate() {
        if (this.searchForm) {
            this.searchForm.controls['toDate'].updateValueAndValidity();
        }
    }
    checkValidationForFromDate() {
        if (this.searchForm) {
            this.searchForm.controls['fromDate'].updateValueAndValidity();
        }
    }
  govIdValidator(event: any) {
    let regex = /^[A-Za-z0-9+-]+$/;
    let rex = new RegExp(regex).test(event.key);
    if (!rex) {
      event.preventDefault();
    }
  }

    memberInfoBlurEvent() {
        if (this.searchForm.controls['memberInfo'].valid && this.searchForm.controls['memberInfo'].value.length === 12) {
            this.searchForm.controls['memberInfo'].setValue(this.searchForm.controls['memberInfo'].value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, "$1-$2-$3-$4"));

        }
        else if (this.searchForm.controls['memberGovtInfo'].valid && this.searchForm.controls['memberGovtInfo'].value.length === 10) {
            this.searchForm.controls['memberGovtInfo'].setValue(this.searchForm.controls['memberGovtInfo'].value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, "$1-$2-$3-$4"));

        }

    }
    /**
     * On paste event for member Info
     */
    onPasteEvent() {
        setTimeout(() => {
            this.searchForm.controls['memberInfo'].setValue(this.searchForm.controls['memberInfo'].value.trim());
        }, 0);
    }

    /**
    * sort table by respective column - Credit Card Search
    * @param sortColumn
    */

    sortByCreditCardTable(sortByColumn: string) {

        if ((this.customerSearchModel.searchBy === Constants.MEMBER && this.searchResponse.fboSearchResultModelList.length === 0)
            || ((this.customerSearchModel.searchBy === Constants.ORDER) && this.searchResponse.orderModelList.length === 0)) {
            return;
        }
        this.pageNumber = 1;

        if (this.isDesc === true) {
            this.isDesc = false;
        }
        else {
            this.isDesc = true;
        }
        this.sortByCreditCard = this.isDesc ? "DESC" : "ASC";
        this.sortByColumn = sortByColumn;
        if (+this.searchType === this.distributorEnum[3]) {
            this.searchRequest.sortOrder = [];
            this.searchRequest.sortOrder.push(this.sortByColumn);
            this.getOrderSearchResultsBycreditCard();
        }
    }

   
    /**
     * get order information from titan
     */
    getOrderByWebOrderId() {
        this.isLoading = true;
        let webOrderInfo = this.searchCriteriaList.find((search: any) => search.searchKey === this.fieldTypes.ORDERNUMBER);
        let searchvalue: string = webOrderInfo.searchValue.toString();
        const countryInfo = this.searchCriteriaList.find((search: any) => search.searchKey === this.fieldTypes.HOMECOUNTRY);
        const selectedCountry : string = countryInfo && countryInfo.searchValue !== this.fieldTypes.ALL ? countryInfo.searchValue.toString():"";

        this._orderservice.getOrderByWebOrderId(null, this.pageNumber, this.pageSize, this.sort, [this.sortColumn], null, null, searchvalue,selectedCountry,this.searchForm.get('alternativeLanguageSearch').value).subscribe(response => {

            if (response && !this.isSearchCancelled) {
                this.isSearchCancelled = false;
                this.isFromTitan = true;
                if(response.content && response.content.length  ){
                    const distributorID = response.content[0].distributorId;
                    this.getAccountStatus(distributorID);
                }
                const countryCodes: string[] = response.content.map(item => item.countryCode);
                if (countryCodes && countryCodes.length > 0) {
                    this.getStoreinfo(countryCodes, response.content, 'web-order');
                }
                this.resetAlternativeLanguageSearchField();
            }
            else {
                this.isFromTitan = false;
                this.ordersPageCount = 0;
                this.searchResponse.orderModelList = new Array<OrderResponse>();
                this.getSearchResults();
                this.isLoading = false;
                this.resetAlternativeLanguageSearchField();
            }
        }, error => {
            this.isFromTitan = false;
            this.ordersPageCount = 0;
            this.searchResponse.orderModelList = new Array<OrderResponse>();
            this.getSearchResults();
            this.isLoading = false;
            this.resetAlternativeLanguageSearchField();
        });

    }
    /**
        * close cancel order popup
        */
    closePopup() {
        this.isSearchCancelled = true;
        this.isLoading = false;
        this.ngProgress.done();
    }

    onPaste(event: any) {
        if (event) {
            event.preventDefault();
            this.lastDigitModel = event.clipboardData.getData('text/plain').replace(/[^0-9]+/g, '');
            if (this.lastDigitModel) {
                this.lastDigitModel = this.lastDigitModel.substring(0, 4);
                this.searchForm.controls['creditCardNumber'].setValue(this.lastDigitModel);
            }
        }
    }

    resetAlternativeLanguageSearchField(){
        this.searchForm.controls['alternativeLanguageSearch'].setValue(false);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/search.component.ts